import api from '../axiosConfig';

export interface ProductAdAccount {
  id: number;
  platform: 'meta' | 'google';
  platform_account_id: string;
  account_name: string | null;
  status: string;
  last_synced_at: string | null;
}

/** 商品に紐付けるキャンペーンの指定。アカウントに1件も無ければアカウント全体を数える。 */
export interface ProductAdCampaignRef {
  ad_account_id: number;
  campaign_id: string;
}

export interface ProductAdCampaign extends ProductAdCampaignRef {
  campaign_name: string | null;
}

export interface ProductAdAvailableCampaign extends ProductAdCampaign {
  platform: 'meta' | 'google';
}

export interface ProductAdAccountConnections {
  accounts: ProductAdAccount[];
  available_accounts: ProductAdAccount[];
  campaigns?: ProductAdCampaign[];
  /** available_accounts 全部について、配信実績にあるキャンペーン。未保存のアカウントの分も返る。 */
  available_campaigns?: ProductAdAvailableCampaign[];
}

export const productAdAccountsService = {
  async get(productId: number): Promise<ProductAdAccountConnections> {
    const response = await api.get(`/products/${productId}/ad-accounts`);
    return response.data.data;
  },

  /** campaigns を渡すと全置換。渡さなければキャンペーンの紐付けは変えない。 */
  async save(
    productId: number,
    adAccountIds: number[],
    campaigns?: ProductAdCampaignRef[],
  ): Promise<ProductAdAccountConnections> {
    const response = await api.put(`/products/${productId}/ad-accounts`, {
      ad_account_ids: adAccountIds,
      ...(campaigns ? { campaigns } : {}),
    });
    return response.data.data;
  },
};
